export const echartsView={
    /**
     * 缩略图下载统计图表
     * @param objData
     * @returns {{yAxis: [{axisLabel: {formatter: string, color: string, fontSize: number}, axisLine: {lineStyle: {color: string}, show: boolean}, name: string, splitLine: {lineStyle: {color: string, type: string}}}], xAxis: [{axisLabel: {color: string, textStyle: {fontSize: number}}, data: *, axisLine: {lineStyle: {color: string}}, type: string}], series: [{barWidth: string, data: *, itemStyle: {normal: {color, shadowBlur: number, barBorderRadius: number[], shadowColor: string}}, label: {normal: {formatter: string, backgroundColor: string, borderRadius: number, distance: number, show: boolean, rich: {a: {color: string, align: string}, b: {borderColor: string, borderWidth: number, width: number, align: string, height: number}, d: {color: string}}, lineHeight: number, position: string[], height: number}}, type: string}, {barWidth: number, data, barGap: string, itemStyle: {normal: {color: string}}, type: string, barCategoryGap: string, animation: boolean}], tooltip: {show: boolean}}}
     */
    drawThumbnailCharts(dateList,numList){
        /*objData.coverageList.forEach(item=>{
            dataMax+=item
        })*/
        let option = {
            tooltip: {
                show:false
            },
            xAxis: [{
                type: 'category',
                data: dateList,
                axisLine: {
                    lineStyle: {
                        color: '#000'
                    }
                },
                axisLabel: {
                    color: '#000',
                    textStyle: {
                        fontSize: 14
                    },
                },
            }],
            yAxis: [{
                name: "单位（次）",
                axisLabel: {
                    formatter: '{value}',
                    color: '#000',
                    fontSize:14
                },
                axisLine: {
                    show: false,
                    lineStyle: {
                        color: '#000'
                    }
                },
                splitLine: {
                    lineStyle: {
                        color: 'rgba(131,101,101,0.2)',
                        type: 'dashed',
                    }
                }
            }],
            series: [{
                type: 'bar',
                data: numList,
                barWidth: '20px',
                itemStyle: {
                    normal: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: 'rgba(0,244,255,1)' // 0% 处的颜色
                        }, {
                            offset: 1,
                            color: 'rgba(0,77,167,1)' // 100% 处的颜色
                        }], false),
                        barBorderRadius: [30, 30, 30, 30],
                        shadowColor: 'rgba(0,160,221,1)',
                        shadowBlur: 4,
                    }
                },
                label: {
                    normal: {
                        show: true,
                        lineHeight: 30,
                        height: 30,
                        backgroundColor: 'rgba(0,160,221,0.1)',
                        borderRadius: 200,
                        position: ['-8', '-60'],
                        distance: 1,
                        formatter: [
                            '    {d|●}',
                            ' {a|{c}次}     \n',
                            '    {b|}'
                        ].join(','),
                        rich: {
                            d: {
                                color: '#3CDDCF',
                            },
                            a: {
                                color: '#000',
                                align: 'center',
                            },
                            b: {
                                width: 1,
                                height: 30,
                                borderWidth: 1,
                                borderColor: '#234e6c',
                                align: 'left'
                            },
                        }
                    }
                }
            }]
        };
        return option
    },
    /**
     * 公报下载统计图表
     * @returns {{yAxis: [{axisLine: {lineStyle: {color: string}, textStyle: {fontSize: number}}, splitLine: {show: boolean}, type: string}], xAxis: [{data: string[], axisLine: {lineStyle: {color: string}}, splitLine: {show: boolean}, axisTick: {show: boolean}, type: string}], calculable: boolean, grid: {top: number, borderWidth: number, bottom: number, textStyle: {color: string}}, series: {symbol: string, data: number[], symbolSize: number, name: string, itemStyle: {color: string}, type: string}, tooltip: {axisPointer: {textStyle: {color: string}, type: string}, trigger: string}}}
     */
    drawBulletinCharts(dateList,naturalList,geographyList) {
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow',
                    textStyle: {
                        color: '#000'
                    }

                }
            },
            grid: {
                borderWidth: 0,
                top: 30,
                bottom: 30,
                textStyle: {
                    color: '#000'
                }
            },
            legend : {
                // orient : 'horizontal',
                top : 5,
                textStyle: {
                    color: '#000',
                }
            },

            calculable: true,
            xAxis: [{
                type: 'category',
                axisLine: {
                    lineStyle: {
                        color: 'rgba(0,0,0,1)'
                    }
                },
                splitLine: {
                    show: false
                },
                axisTick: {
                    show: false
                },
                data:  dateList
            }],

            yAxis: [{
                name: "单位（次）",
                type: 'value',
                splitLine: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                        color: 'rgba(0,0,0,1)'
                    },
                    textStyle:{
                        fontSize:14,
                    }
                }

            }],
            series: [{
                name: "地理国情公报下载",
                type: 'line',
                symbolSize: 10,
                symbol: 'circle',
                itemStyle: {
                    color: "#FF5D5D"
                },
                data:naturalList
            },{
                name: "自然资源公报下载",
                type: 'line',
                symbolSize: 10,
                symbol: 'circle',
                itemStyle: {
                    color: "rgba(0,160,221,1)"
                },
                data:geographyList
            }]
        }
        return options
    },
    drawDemoChart(classData){
        let option = {
            backgroundColor:"#000",
            tooltip : {
                trigger : 'item',
                formatter : '{a} <br/>{b}: {c} ({d}%)'
            },
            legend : {
                // orient : 'horizontal',
                top : 5,
                textStyle: {
                    color: '#f2f2f2',
                }
            },
            series : [
                {
                    name : '市政设备',
                    type : 'pie',
                    selectedMode : 'single',
                    radius : [ 0, '40%' ],
                    center: ['50%', '65%'],
                    // itemStyle: {
                    // 	normal: {
                    // 		borderColor: '#fff',
                    // 		borderWidth: 2
                    // 	}
                    // },
                    label: {
                        normal: {
                            position: 'inner'
                        }
                    },
                    labelLine : {
                        show : false
                    },
                    data : classData
                },
                /*{
                    name : '市政设备',
                    type : 'pie',
                    radius : [ '50%', '65%' ],
                    center: ['50%', '65%'],
                    label : {
                        // formatter : '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
                        // backgroundColor : '#eee',
                        // borderColor : '#dff8ff',
                        // borderWidth : 1,
                        // borderRadius : 4,
                        rich : {
                            a : {
                                color : '#999',
                                lineHeight : 22,
                                align : 'center'
                            },
                            hr : {
                                borderColor : '#aaa',
                                width : '100%',
                                borderWidth : 0.5,
                                height : 0
                            },
                            b : {
                                fontSize : 16,
                                lineHeight : 33
                            },
                            per : {
                                color : '#eee',
                                backgroundColor : '#334455',
                                padding : [ 2, 4 ],
                                borderRadius : 2
                            }
                        }
                    },
                    data : [
                        {
                            value : 6681,
                            name : '电力井盖'
                        },
                        {
                            value : 1445,
                            name : '公安井盖'
                        },
                        {
                            value : 678,
                            name : '燃气井盖'
                        },
                        {
                            value : 403,
                            name : '路灯井盖'
                        },
                        {
                            value : 6543,
                            name : '通信井盖'
                        },
                        {
                            value : 14753,
                            name : '污水井盖'
                        },
                        {
                            value : 7355,
                            name : '路灯'
                        },
                        {
                            value : 54,
                            name : '古树名木'
                        },
                        {
                            value : 2608,
                            name : '护树设施'
                        },
                        {
                            value : 30487,
                            name : '行树'
                        },
                        {
                            value : 59,
                            name : '绿地附属设施'
                        },
                        {
                            value : 2004,
                            name : '消防设施'
                        }
                    ]
                }*/
            ]
        };
        return option
    }
}
